import React from 'react';
import Text from '../Text';
import TextLink from '../TextLink';
import UpgradeIcon from './icons/UpgradeIcon';

const HIDE_FAQ_LINK = true; // for now, until we do have an FAQ

export default function BackupFooter({ faqUrl = 'https://help.tokentax.co/en/' }: { faqUrl?: string }) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 text-muted">
      <UpgradeIcon name="info" />
      <Text variant="muted" className="text-sm font-semibold">
        Your current account will be backed up first
      </Text>
      {!HIDE_FAQ_LINK && (
        <TextLink to={faqUrl} external className="text-sm underline">
          Upgrade FAQ
        </TextLink>
      )}
    </div>
  );
}
